module.exports = __webpack_public_path__ + "static/media/StJohnPaulCatholicAcademyColumbia.3b88839c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/schools/main/StJohnPaulCatholicAcademyColumbia.jpg
// module id = 771
// module chunks = 0